import { Box, Collapse, Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import type { IconType } from "react-icons";
import { cardStyles, eyebrowStyles } from "./styleTokens";

type Props = {
  title: string;
  icon?: IconType;
  children: React.ReactNode;
  // Quando informados, o cabeçalho ganha um chevron pra recolher o card —
  // usado em "Identificação do disparo", que colapsa sozinho ao escolher
  // o primeiro canal de disparo (mais espaço pra escrever a mensagem) mas
  // continua manualmente reabrível.
  isOpen?: boolean;
  onToggle?: () => void;
};

// Card de seção no padrão da tela "Progresso Leilão" (SectionCard/ProposalClientCard
// em CreditAuctionProposalsPage): borda + radius 16px, cabeçalho centralizado
// com ícone + rótulo pequeno/maiúsculo/tracked.
export default function SectionCard({ title, icon: IconComp, children, isOpen, onToggle }: Props) {
  const collapsible = onToggle !== undefined;
  return (
    <Box {...cardStyles} p={{ base: 4, md: 5 }}>
      <Flex align="center" justify="center" gap={2} mb={collapsible && !isOpen ? 0 : 4} position="relative">
        {IconComp && <Icon as={IconComp} boxSize={4} color="secondary" />}
        <Text {...eyebrowStyles}>{title}</Text>
        {collapsible && (
          <IconButton
            aria-label={isOpen ? `Recolher ${title}` : `Expandir ${title}`}
            icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            size="xs"
            variant="ghost"
            position="absolute"
            right={0}
            onClick={onToggle}
          />
        )}
      </Flex>
      {collapsible ? <Collapse in={isOpen}>{children}</Collapse> : children}
    </Box>
  );
}
